<template>
  <v-container class="pa-0">
    <!-- <v-tooltip bottom>
      <template v-slot:activator='{ on, attrs }'>
        <v-btn
          class='mx-2'
          fab
          dark
          small
          v-bind='attrs'
          v-on='on'
          color='yellow'
          :loading='cnsmrLoading'
          @click='download'
        >
          <v-icon dark>mdi-package-down</v-icon>
        </v-btn>
      </template>
<span>Export</span>
</v-tooltip> -->
    <v-btn color="primary" text dense dark block @click="download">
      <v-icon>mdi-download</v-icon>

      Export CSV
    </v-btn>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
import { authAxios } from '@/extra-functions/axios.extra'

export default {
  name: 'export-consumers',
  created() {
  },
  computed: {
    ...mapState({
      storeId: state => state.settings.storeId,
      stores: state => state.branchLocation.list,
    }),
    storeName() {
      return this.stores.find(e => e.id === this.storeId).name
    },
  },
  methods: {
    async download() {
      const { storeId } = this.$store.state.settings
      try {
        this.$swal('loading', {
          config: {
            loading: {
              text: 'Exporting...',
            },
          },
        })
        const axios = authAxios()
        const { data } = await axios.get(`/v2/stores/${storeId}/export-receivables-csv`, {
          responseType: 'blob', // 👈 use blob, not text, for files
          headers: {
            Accept: 'text/csv',
          },
        })
        const BOM = '\uFEFF' // UTF-8 BOM
        const blob = new Blob([BOM, data], {
          type: 'text/csv;charset=utf-8;',
        })
        const url = window.URL.createObjectURL(blob)
        // Create a temporary <a> element to trigger download
        const link = document.createElement('a')
        link.href = url
        const storeName = this.storeName.replace(' ', '_').toLowerCase()
        const pad = n => String(n).padStart(2, '0')
        const d = new Date()
        const ts = `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`
        link.setAttribute('download', `${storeName}_consumer_loans_${ts}.csv`)
        link.click()
        // Cleanup
        link.remove()
        URL.revokeObjectURL(url)
        this.$swal('success', {
          config: {
            title: {
              text: 'Export Success',
            },
          },
        })
      } catch (e) {
        this.$swal('error', {
          config: {
            title: {
              text: e.message,
            },
          },
        })
      }
    },
  },
}
</script>
